import { render, staticRenderFns } from "./POSIcon.vue?vue&type=template&id=5f30ccb7&scoped=true&"
import script from "./POSIcon.vue?vue&type=script&lang=ts&"
export * from "./POSIcon.vue?vue&type=script&lang=ts&"
import style0 from "./POSIcon.vue?vue&type=style&index=0&id=5f30ccb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f30ccb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f30ccb7')) {
      api.createRecord('5f30ccb7', component.options)
    } else {
      api.reload('5f30ccb7', component.options)
    }
    module.hot.accept("./POSIcon.vue?vue&type=template&id=5f30ccb7&scoped=true&", function () {
      api.rerender('5f30ccb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/POSIcon.vue"
export default component.exports